// Module
var code = "<p>[# summary]</p> <h3 id=\"aktif-symbol\">Aktif {symbol}</h3> <p>{description}<br>Piyasaya süren {issuer}</p> <p>Amerikan Doları (işeret: $; sembol: USD $) ABD&#39;nin resmi para birimidir.</p> ";
// Exports
export default code;